import domPurify from 'dompurify';
import type { JSX } from 'react';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface EventDetailsDescriptionSectionProps {
    description?: string | null;
    eventGuid: string;
}

export function EventDetailsDescriptionSection({
    description,
    eventGuid,
}: EventDetailsDescriptionSectionProps): JSX.Element | null {
    if (!description) {
        return null;
    }

    return (
        <Accordion type="multiple" className="pt-0">
            <AccordionItem value={`details-${eventGuid}`}>
                <AccordionTrigger>Details</AccordionTrigger>
                <AccordionContent>
                    <div
                        className="text-muted-foreground pt-2 text-sm break-all whitespace-pre-wrap select-text"
                        dangerouslySetInnerHTML={{
                            __html: domPurify.sanitize(description),
                        }}
                    />
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
}
